import * as React from 'react'
import { Platform } from 'react-native'
import { OrderConfirmedPageView } from './OrderConfirmedPageView.native'
import { OrderPageView } from './OrderPageView.native'
import { useAppSelector } from '../../../../state/hooks'

interface ReceiptViewProps {
	prices: any
	orderData: any
	automaticPrint?: boolean
	isOrderConfirmedModal: boolean
}

export const StartPrintReceiptView = ({
	prices,
	orderData,
	automaticPrint = false,
	isOrderConfirmedModal = false,
}: ReceiptViewProps) => {
	const { loadedData } = useAppSelector(state => state.data)
	const { orderNumber: orderNum } = useAppSelector(state => state.checkout)
	const { webOrdersEnabled } = useAppSelector(state => state.settings)
	const { selectedMethods } = useAppSelector(state => state.checkout)

	const orgName = loadedData[global.org].name ? loadedData[global.org].name : ''
	const orgAddress = loadedData[global.org].address ? loadedData[global.org].address : ''
	const orgURL = loadedData[global.org].webURL
		? loadedData[global.org].webURL.replace(/^(http:\/\/|https:\/\/)/, '')
		: ''
	let orgPhone = loadedData[global.org].phoneNumber ? loadedData[global.org].phoneNumber : ''

	if (orgPhone !== '') {
		if (orgPhone.length === 11 && orgPhone[0] === '1') {
			orgPhone = orgPhone.slice(1)
		}
		const match = orgPhone.match(/^(\d{3})(\d{3})(\d{4})$/)
		if (match) {
			orgPhone = '(' + match[1] + ')-' + match[2] + '-' + match[3]
		}
	}

	const orderType: string = orderData.isDineIn
		? 'dineIn'
		: orderData.isDelivery || orderData?.type === 'delivery'
			? 'delivery'
			: 'takeOut'
	const getAppType = (): string => {
		if (isOrderConfirmedModal) {
			if (global.pos) return 'POS'
			if (global.kiosk) return 'Kiosk'
		}
		return orderData?.source?.type || orderData?.channelData?.appType || 'unknown'
	}
	const appType = getAppType()

	const orgLogo = loadedData[global.org].logo ? loadedData[global.org].logo : ''

	const orgLogoDark = loadedData[global.org].logoDark ? loadedData[global.org].logoDark : ''
	const ReceiptView = !isOrderConfirmedModal ? OrderPageView : OrderConfirmedPageView
	const orderNumber = orderData.number ?? orderNum
	const source = orgLogoDark ? orgLogoDark : orgLogo

	return isOrderConfirmedModal && !selectedMethods.print ? null : (
		<ReceiptView
			prices={prices}
			orderData={orderData}
			orderNumber={orderNumber}
			source={source}
			orgURL={orgURL}
			orgName={orgName}
			orgAddress={orgAddress}
			orgPhone={orgPhone}
			orderType={orderType}
			appType={appType}
			webOrdersEnabled={webOrdersEnabled}
		/>
	)
}
